import { render, staticRenderFns } from "./phone.vue?vue&type=template&id=2d8520fa&"
import script from "./phone.vue?vue&type=script&lang=ts&"
export * from "./phone.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports